import { __assign } from '../../../node_modules/tslib/tslib.es6.js';
import { jsx } from 'react/jsx-runtime';
import { Modal as Modal$1 } from '@cheetahdigital/console-kit-cx';
import styles from './index.module.scss.js';

var Modal = function (_a) {
    var isActive = _a.isActive, _b = _a.hasCloseIcon, hasCloseIcon = _b === void 0 ? true : _b, onClose = _a.onClose, children = _a.children;
    return (jsx(Modal$1, __assign({ isSolid: true, isTransparent: true, hasCloseIcon: hasCloseIcon, isFullscreen: false, showModal: isActive, onClose: onClose }, { children: jsx("div", __assign({ className: styles.modalContainer }, { children: children }), void 0) }), void 0));
};

export { Modal as default };
